import { RouteRecordRaw } from 'vue-router';

const myTasksRoutes: Array<RouteRecordRaw> = [
  {
    path: 'my-tasks/:taskId?',
    component: () =>
      import('@/app/my-tasks/components/my-tasks-components.vue'),
    name: 'app.my-tasks',
  },
];

export default myTasksRoutes;
